/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolcardrecording2Inputs */

const en_toolcardrecording2 = /** @type {(inputs: Toolcardrecording2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`recording…`)
};

const pt_toolcardrecording2 = /** @type {(inputs: Toolcardrecording2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a registar…`)
};

/**
* | output |
* | --- |
* | "recording…" |
*
* @param {Toolcardrecording2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const toolcardrecording2 = /** @type {((inputs?: Toolcardrecording2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolcardrecording2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toolcardrecording2(inputs)
	return pt_toolcardrecording2(inputs)
});
export { toolcardrecording2 as "toolCardRecording" }